module.exports = __webpack_public_path__ + "../resources/img/weather_partly-cloudy-day.5dfb8cf9.svg";